export const themeAction = (displayMode) => ({
  type: 'CHANGE_MODE',
  displayMode
});
